import { Injectable } from '@angular/core';
import { AtlasMobileService } from '../ol-map/atlas-mobile.service';
import { unByKey } from 'ol/Observable.js';

@Injectable({
    providedIn: 'root',
})
export class AtlasMobileFilterService {
    private urlEventsKey: any;

    constructor(public atlasMobileService: AtlasMobileService) {}

    setFilter(filter: string, value: any): void {
        const currentValue = this.atlasMobileService.olMapService.filter.get(filter);
        if (currentValue === value) {
            return;
        }
        this.atlasMobileService.olMapService.filter.set(filter, value);
        this.atlasMobileService.loadLayer();
    }
    setQueryParams(): void {
        if (this.urlEventsKey) {
            unByKey(this.urlEventsKey);
        }
        this.urlEventsKey = this.atlasMobileService.olMapService.map.on('moveend', () => {
            this.atlasMobileService.changeUrl();
        });
    }

    destroy(): void {
        if (this.urlEventsKey) {
            unByKey(this.urlEventsKey);
            this.urlEventsKey = undefined;
        }
    }
}